import { Controller } from "stimulus";
import { loadFlatpickr } from "../util/load_package";

let Flatpickr;

let flatpickrSingleDateInstance;
let flatpickrRangeDateInstance;

export default class extends Controller {
  static targets = ["singleInput", "rangeInput"];

  async connect() {
    Flatpickr = await loadFlatpickr();

    flatpickrSingleDateInstance = Flatpickr(this.singleInputTarget, {
      enableTime: true,
      static: true,
      dateFormat: "d-m-Y H:i",
    });

    flatpickrRangeDateInstance = Flatpickr(this.rangeInputTarget, {
      mode: "range",
      static: true,
      dateFormat: "d-m-Y H:i",
    });
  }

  showSinglePicker() {
    flatpickrSingleDateInstance.open()
  }

  showRangePicker() {
    flatpickrRangeDateInstance.open()
  }
}
